import { FunctionComponent } from 'react';
import { WorkspaceInvite } from '../../../../models/workspace';

type Props = {
  invite: WorkspaceInvite;
  selectedWorkspace: string | null;
  onSelect: (id: string) => void;
};

export const WorkspaceInviteRow: FunctionComponent<Props> = ({ invite, selectedWorkspace, onSelect }) => {
  const isSelected = selectedWorkspace === invite.workspaceId;

  return (
    <div
      onClick={() => onSelect(invite.workspaceId)}
      className={`group flex cursor-pointer p-4 transition postel-bg-color
        ${isSelected ? 'border-blue-800 border-2 rounded-md' : 'bg-white border-gray-200 hover:bg-gray-100'}
      `}
    >
      <div className='flex w-full items-center justify-between'>
        <div>
          <div className='text-sm font-medium text-gray-900'>{invite.workspaceName}</div>
          {invite.company?.name && <div className='text-xs text-gray-600'>{invite.company.name}</div>}
        </div>

        <div className={`h-4 w-4 rounded-full border-2 ${isSelected ? 'border-blue-600 bg-blue-600' : 'border-gray-400'}`} />
      </div>
    </div>
  );
};
